import type { ReadonlyDate } from '..'
import { createTimeout } from '.'

/**
 * Creates a promise by the given amount
 *
 * @see {createTimeout} for further behaviour documentation
 */
export const delay = (timeOrDate: number | ReadonlyDate): Promise<void> => new Promise((resolve) => createTimeout(resolve, timeOrDate))
